import React, { Fragment } from 'react';

const TopsAnalitics = props => {
  const { data } = props;
  return (
    <Fragment>
      {data.map(el => {
        return (
          <div className="b-col-4 b-col-sm-12" key={el.title}>
            <h2 className="h2-title">{el.title}</h2>
            <div className="separator-line" />
            <ol className="country-list">
              {el.list.map((item, index) => {
                return (
                  <li key={index} className="country-list__itm">
                    {index + 1}. {item}
                  </li>
                );
              })}
            </ol>
          </div>
        );
      })}
    </Fragment>
  );
};

export default TopsAnalitics;



// WEBPACK FOOTER //
// ./src/scenes/Analytics/TopsAnalitics.js